const button = "_button_i91xf_17";
const destructive = "_destructive_i91xf_116";
const styles = {
  button,
  "icon-only": "_icon-only_i91xf_59",
  "has-icon": "_has-icon_i91xf_66",
  destructive
};
export {
  button,
  styles as default,
  destructive
};
//# sourceMappingURL=Button.module.css.js.map
